import React, { useRef } from "react";
import Button from "../../ui/Button";
import "./file-upload.css";

export default function FileUpload({
  label,
  name,
  value,
  onChange,
  error,
  accept = "image/*,.pdf",
  required,
}) {
  const fileRef = useRef(null);

  const handleClick = () => {
    fileRef.current?.click();
  };

  const isFileObject = value instanceof File;
  const isUrlValue = typeof value === "string" && value.trim() !== "";
  const isImageFile = isFileObject && value.type?.startsWith("image/");
  const isImageUrl =
    isUrlValue &&
    /\.(jpg|jpeg|png|gif|webp|bmp|svg)(\?.*)?$/i.test(value);

  const fileName = isFileObject
    ? value.name
    : isUrlValue
    ? value.split("?")[0].split("/").pop()
    : null;

  return (
    <div className="file-upload d-flex flex-column gap-2">
      
      {label && (
        <label htmlFor={name} className="text-sm fw-medium">
          {label} {required && "*"}
        </label>
      )}

      {/* Hidden Input */}
      <input
        type="file"
        name={name}
        ref={fileRef}
        onChange={onChange}
        accept={accept}
        hidden
      />

      {/* Button + File Name */}
      <div className="d-flex align-center gap-2">
        <Button type="button" onClick={handleClick}>
          Choose File
        </Button>

        <span className="file-upload-name">
          {fileName || "No file chosen"}
        </span>
      </div>

      {/* Image Preview */}
      {(isImageFile || isImageUrl) && (
        <img
          src={isImageFile ? URL.createObjectURL(value) : value}
          alt="preview"
          className="file-upload-preview"
        />
      )}

      {/* Error */}
      {error && (
        <span className="text-danger text-xs">{error}</span>
      )}
    </div>
  );
}